<template>
  <v-form
		id="newLocationForm"
		class="pa-5" 
		ref="form"
		v-model="valid"
		lazy-validation
  >
		<v-text-field
				v-model="name"
				label="Name"
				></v-text-field>
				<v-select
				v-model="description"
				label="Description"
				:items="[
					'The appointment will be held at the following location',
					'The appointment will be held via an easy to use online meeting tool', 
					'The appointment will be held over the phone'
				]"
				></v-select>		
				<v-row>
					<v-col>
						<v-text-field
						v-model="address1"
						label="Address Line 1"
						></v-text-field>
					</v-col>
					<v-col>
						<v-text-field
						v-model="address2"
						label="Address Line 2"
						></v-text-field>
					</v-col>
				</v-row>
				<v-row>
					<v-col>
						<v-text-field
						v-model="city"
						label="City, County"
						></v-text-field>
					</v-col>
					<v-col>
						<v-text-field
						v-model="postcode"
						label="Postcode"
						></v-text-field>
					</v-col>
				</v-row>
				<v-row>
					<v-col>
						<v-text-field
						v-model="mapLink"
						label="Location Map Link"
						></v-text-field>
					</v-col>
				</v-row>
    <v-btn
		color="error"
		class="mr-4"
		@click="reset"
    >
		Reset Form
    </v-btn>

    <v-btn
		:disabled="!valid"
		color="success"
		class="mr-4"
		@click="createLocation"
    >
		Create Location
    </v-btn>
  </v-form>
</template>

<script>
export default {
  name: 'NewLocationForm',
  data: () => (
	{
		valid: true,
		name: "",
		description: "",
		mapLink: "",
		intro: "",
		address1: "",
		address2: "",
		city: "",
    }),
	methods: {
		createLocation () {
			var self = this;
			let newLocation = { 
				"publishStatus": "live",
				'name': this.name,
				'description': this.description,
				'mapLink': this.mapLink,
				'intro': this.intro,
				'address1': this.address1,
				'address2': this.address2,
				'city': this.city,
				'postcode': this.postcode
			}
			self.$store.dispatch( "addDoc", {
				collection: "locations",
				data: newLocation
			} ).then( function( ref ){
				self.$store.dispatch("bindAnything", {id: ref.id, collection: "locations", then: "SET_ANYTHING", reference: "locations"} )
				self.$refs.form.reset();
				self.$emit("created", ref.id, "location" )

			} );
		}, 
		reset: function(){
			this.$refs.form.reset();
		}
	},
};
</script>
